import React from "react";
import FoundationImg from "./../../assets/images/foundation.png";
import FoundationImg2 from "./../../assets/images/foundation2.png";
import FoundationImg3 from "./../../assets/images/foundation3.png";
import FoundMini from "./../../assets/images/found_mini.png";
import "./foundation.css";
const Foundation = () => {
  const shopNow = () => {
    window.open(
      'https://a.co/d/1Tnoxt3',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  return (
    <div className="foundation" >
      <div className="foundation_left">
        <div style={{ flex: 1, padding: 0, margin: 0 }}>
          <img
            src={FoundationImg2}
            alt=" "
            width="100%"
            height="100%"
            className="found_desktop"
          />
          <img
            src={FoundationImg3}
            alt=" "
            width="100%"
            className="found_mobile"
          />
        </div>
        <div style={{ flex: 3, padding: 0, margin: 0 }}>
          <img src={FoundationImg} alt=" " width="100%" height="100%" />
        </div>
      </div>
      <div className="foundation_right">
        <div style={{ flex: 3 }}>
          <div className="found_heading">
            <div className="found_mini">
              <img src={FoundMini} alt=" " />
            </div>
            <p className="found_heading">
              Foundation <br /> Blender
            </p>
          </div>
          <p className="found_description">
            Designed with an exclusive plush material and easy to grip shape,
            creates a makeup application that will surprise you the pros.
            Rounded edges of the blending sponge guarantee effortless blending.
            Plush sponge material ensures makeup sits on the sponge creating a
            smoother, more uniform blending experience and a professional makeup
            result.
          </p>
          <button className="primary_btn" onClick={()=> shopNow()}>Shop Now</button>
        </div>
        <div style={{ flex: 1 }} className="found_content_spacer"></div>
      </div>
    </div>
  );
};

export default Foundation;
